// React and related imports
import React from 'react';

// React Router
import { Navigate, Outlet, useLocation } from 'react-router-dom';

// User Info Context
import { useUserInfo } from './UserInfoProvider';
import { useAuth } from './AuthProvider';

// Enums
import { DashboardUserRole } from '../common/enums/DashboardUserRole';

interface RoleProtectedRouteProps {
  allowedRoles: DashboardUserRole[];
}

export const RoleProtectedRoute: React.FC<RoleProtectedRouteProps> = ({
  allowedRoles,
}) => {
  const { userInfo, loadingUserInfo } = useUserInfo();
  const { isAuthenticated } = useAuth();
  const location = useLocation();

  // Wait if user is authenticated but user info hasn't loaded yet
  if (loadingUserInfo || (isAuthenticated && !userInfo)) {
    return null;
  }

  if (!userInfo || !allowedRoles.includes(userInfo.role)) {
    return <Navigate to="/unauthorized" state={{ from: location }} replace />;
  }

  return <Outlet />;
};
